import { TextButton as AlphaTextButton } from '@oneaudi/unified-web-alpha-components';

export default AlphaTextButton;
